var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('div',[_c('router-view'),_c('CookieConsent'),_c('GlobalSpinner')],1),_c('FooterPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }